import { Typography } from '@mui/material';
import type { FileSearchRecord } from '@repo/api-gw-sdk';
import { Base64 } from 'js-base64';

import { TextLink } from '@/components/shared/textLink';
import { useRoles } from '@/contexts/useRoles';

export const PathCell = ({ entity }: { entity: FileSearchRecord }) => {
  const { isAuthorized } = useRoles();

  // const hasValidSnapshot = entity.snapshots.some((x) =>
  //   isDateValid(x.generatedOn)
  // );

  return (
    entity.path && (
      <TextLink
        // disabled={!isAuthorized('read:files') || !hasValidSnapshot}
        disabled={!isAuthorized('read:files')}
        href={`/explorer/${entity.resourceId}?file=${Base64.encode(entity.path)}`}
      >
        <Typography color='inherit'>{entity.path}</Typography>
      </TextLink>
    )
  );
};
